module.exports = __webpack_public_path__ + "static/img/4.ee18f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = q/uz
// module chunks = 1